import { Navigate } from "react-router-dom";
import { useAdminAuth } from "../contexts/AdminAuthContext";

export default function AdminProtectedRoute({ children }) {
  const { admin, loading } = useAdminAuth();
  if (loading) {
    return <div className="container-pad py-32 text-center text-slate-500">Loading...</div>;
  }
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
}
